import { useEffect, useState } from "react";

const navLinks = [
  { href: "#top", label: "首页" },
  { href: "#hot", label: "今日热搜" },
  { href: "#latest", label: "新瓜速递" },
  { href: "#category", label: "分类快报" },
  { href: "#debate", label: "网友热议" },
  { href: "#about", label: "关于本站" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur-md shadow-card" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-6xl px-4 md:px-6" aria-label="主导航">
        <div className="flex h-16 items-center justify-between">
          <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-lg text-white">
              <i className="ri-fire-fill" aria-hidden="true" />
            </span>
            <span className="font-heading text-lg font-bold text-foreground-900">吃瓜最新</span>
            <span className="hidden sm:inline-flex rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-700">
              今日新瓜
            </span>
          </a>

          <div className="hidden items-center gap-1 md:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700 whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#latest"
              className="ml-2 inline-flex whitespace-nowrap items-center rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary-600"
            >
              <i className="ri-flashlight-line mr-1.5" aria-hidden="true" />
              围观新瓜
            </a>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 md:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} aria-hidden="true" />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#latest"
              onClick={() => setOpen(false)}
              className="mt-1 rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-white"
            >
              围观新瓜
            </a>
          </div>
        </div>
      )}
    </header>
  );
}